var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-box"},[_c('div',{staticClass:"h1"},[_vm._v("历史更新查询")]),_c('search',{staticClass:"search",staticStyle:{"align-self":"flex-end","margin-right":"100px"},attrs:{"type":"mini"},on:{"tap-item":_vm.handleInput}}),_c('time-line',{attrs:{"key-word":_vm.KeyWord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }